import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from '@jcm/design-system';
import { Box, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import CustomAlert from '../../../../../../shared/components/customAlert/customAlert';

import ModalConcluirObrigacao from '../../../components/obrigacoes/ModalConcluirObrigacao/ModalConcluirObrigacao';
import AcoesAnexo from '../FormObrigacoes/Acoes/AcoesAnexo';
import ModalAlterarData from '../FormObrigacoes/Acoes/ModalAlterarData/ModalAlterarData';
import ModalCancelarObrigacao from '../FormObrigacoes/Acoes/ModalCancelarObrigacao/ModalCancelarObrigacao';
import Anexos from '../FormObrigacoes/Anexos/Anexos';
import CalculoPeriodicidade from '../FormObrigacoes/CalculoPeriodicidade/CalculoPeriodicidade';
import CustomHeader from '../FormObrigacoes/CustomHeaderForm/CustomHeader';
import EnvioEmails from '../FormObrigacoes/EnvioEmails/EnvioEmails';
import GerenciarObrigacao from '../FormObrigacoes/GerenciarObrigacao/GerenciarObrigacao';
import LogsModal from '../FormObrigacoes/LogsModal/index';

import ObrigacoesService from '../../../services/Obrigacoes/Obrigacoes.service';
import {
	obrigacaoEstaConcluida,
	usuarioEhAdmin,
	verificarAprovadorPrincipal,
	verificarResponsavelPrincipal,
} from '../../../utils/determinarAcessoObrigacoes';

import { useGovernancaContext } from '../../../../../../context/GovernancaContext';
import { TipoDadoEnum } from '../../../ts/enums/TipoDadoEnum';
import { CriarEtapaPayload, TEtapa } from '../../../ts/types/ObrigacaoEtapa/Etapas/Etapa';
import { TObrigacao } from '../../../ts/types/ObrigacaoEtapa/Obrigacoes/Obrigacoes';
import { criarEtapaZodSchema } from '../../../zod/validations/CriarEtapaZodSchema';
import { CriarAnexoPayload } from '../../../ts/types/ObrigacaoEtapa/common/Anexos';
import { EnumTipoAnexo } from '../../../ts/enums/TipoAnexoEnum';

interface FormEtapaProps {
	initialData?: Partial<CriarEtapaPayload>;
	onSave: (data: CriarEtapaPayload) => void;
	onClose?: () => void;
	isEdit?: boolean;
	empresaId: number | string;
	headerTitle?: string;
	status?: string;
	empresaNome?: string;
	onObrigacaoChange: (obrigacaoAtualizada: TObrigacao) => void;
	obrigacao: TObrigacao;
	etapa?: TEtapa;
	onAttachClick?: () => void;
	onAtualizar?: () => void;
	onAlteracao?: (alterado: boolean) => void;
}

const FormEtapas: React.FC<FormEtapaProps> = ({
	initialData = {},
	onClose,
	isEdit = false,
	empresaId,
	empresaNome,
	onObrigacaoChange,
	obrigacao,
	etapa,
	onAtualizar,
	onAlteracao,
}) => {
	const _obrigacoesService = new ObrigacoesService();
	const { usuario } = useGovernancaContext();

	const [isModalAlterarVencimento, setIsModalAlterarVencimento] = useState(false);
	const [isModalConluirObrigacao, setIsModalConluirObrigacao] = useState(false);
	const [isModalCancelarObrigacao, setIsModalCancelarObrigacao] = useState(false);
	const [isModalLogs, setIsModalLogs] = useState(false);
	const [isModalAnexosVisible, setIsModalAnexosVisible] = useState(false);
	const [dadosCarregados, setDadosCarregados] = useState(false);
	const [anexoData, setAnexoData] = useState<CriarAnexoPayload>({
		arquivo: null,
		descricao: '',
	});
	const [precisaAtualizarListagem, setPrecisaAtualizarListagem] = useState(false);
	const [alert, setAlert] = useState<{
		type: 'success' | 'error';
		content: string;
		title?: string;
	} | null>(null);

	const [data, setData] = useState<CriarEtapaPayload>({
		nome: initialData.nome || '',
		aprovadorPrincipal: initialData.aprovadorPrincipal || 0,
		responsavelPrincipal: initialData.responsavelPrincipal || 0,
		aprovadoresSelecionados: initialData.aprovadoresSelecionados || [],
		responsaveisSelecionados: initialData.responsaveisSelecionados || [],
		acompanhamento: initialData.acompanhamento || '',
		fundamentacaoLegal: initialData.fundamentacaoLegal || '',
		datas: initialData.datas || '',
		prazoLegal: initialData.prazoLegal || '',
		temporalidade: initialData.temporalidade || '',
		ehLegal: initialData.ehLegal,
		formaCumprimento: initialData.formaCumprimento || '',
		listaEmailSelecionados: initialData.listaEmailSelecionados || [],
		listaEmailSomenteAtrasoSelecionados: initialData.listaEmailSomenteAtrasoSelecionados || [],
		origemSelecionada: initialData.origemSelecionada,
		parentId: obrigacao?.id,
		// E-mail
		antecedenciaSelecionada: initialData.antecedenciaSelecionada,
		frequenciaVencidaSelecionada: initialData.frequenciaVencidaSelecionada,
		diaUtil: initialData.diaUtil,
		dataVencimento: initialData.dataVencimento,
		dataFinal: initialData.dataFinal,
		// Campos adicionais
		justificativaAtraso: initialData.justificativaAtraso || '',
		justificativaCancelar: initialData.justificativaCancelar || '',
		justificativaImplementacao: initialData.justificativaImplementacao || '',
		justificativaNaoAprovacao: initialData.justificativaNaoAprovacao || '',
		justificativaNaoAprovacaoDataAlterada: initialData.justificativaNaoAprovacaoDataAlterada || '',
		justificativaNaoAprovarCancelamento: initialData.justificativaNaoAprovarCancelamento || '',
		pontoMelhoria: initialData.pontoMelhoria || '',
		reaprovada: initialData.reaprovada || false,
		obrigacaoConcluida: initialData.obrigacaoConcluida || false,
		emAtraso: initialData.emAtraso || false,
		emAtrasoDataFinalSolicitada: initialData.emAtrasoDataFinalSolicitada || false,
		podeConcluir: initialData.podeConcluir || false,
		novaDataFinal: initialData.novaDataFinal,
		justificativaDataAlterada: initialData.justificativaDataAlterada || '',
		// Conclusao
		dataConclusaoObrigacao: new Date(),
		dataHoje: new Date(),
		estadoStatusAprovada: initialData.estadoStatusAprovada,
		estadoStatusCancelamento: initialData.estadoStatusCancelamento || 0,
		estadoStatusAlterarData: initialData.estadoStatusAlterarData || null,
	});

	const [loading, setLoading] = useState(false);

	const schema = criarEtapaZodSchema(isEdit);
	type FormValues = z.infer<ReturnType<typeof criarEtapaZodSchema>>;

	useEffect(() => {
		if (precisaAtualizarListagem) {
			onAlteracao?.(true);
		}

		setDadosCarregados(true);
	}, [precisaAtualizarListagem]);

	const handleOpenAlterarVencimentoModal = () => {
		if (dadosCarregados) {
			setIsModalAlterarVencimento(true);
		} else {
			setAlert({
				type: 'error',
				content: 'Aguarde o carregamento das informações antes de continuar.',
			});
		}
	};

	const handleOpenConcluirObrigacaoModal = () => {
		if (dadosCarregados) {
			setIsModalConluirObrigacao(true);
		} else {
			setAlert({
				type: 'error',
				content: 'Aguarde o carregamento das informações antes de continuar.',
			});
		}
	};

	const handleOpenCancelarObrigacaoModal = () => {
		if (dadosCarregados) {
			setIsModalCancelarObrigacao(true);
		} else {
			setAlert({
				type: 'error',
				content: 'Aguarde o carregamento das informações antes de continuar.',
			});
		}
	};

	const handleCloseFormulario = () => {
		if (precisaAtualizarListagem && onAtualizar) {
			onAtualizar();
		}
		onClose?.();
	};

	const handleAnexoChange = (field: keyof CriarAnexoPayload, value: unknown) => {
		setAnexoData((prev) => ({ ...prev, [field]: value }));
	};

	const handleAttachClick = async () => {
		if (isModalAnexosVisible) return;

		setIsModalAnexosVisible(true);

		try {
			const anexosAtualizados = await _obrigacoesService.getListaAnexos(empresaId, etapa?.id as number);
			setAnexoData((prevState) => ({
				...prevState,
				anexos: anexosAtualizados,
			}));
		} catch (error) {
			console.error('Erro ao buscar anexos:', error);
			setAlert({ type: 'error', content: 'Erro ao buscar anexos.' });
		}
	};

	const handleCloseAnexosModal = () => {
		if (precisaAtualizarListagem || anexoData.arquivo || anexoData.descricao) {
			setPrecisaAtualizarListagem(true);
			onAlteracao?.(true);
		}

		setIsModalAnexosVisible(false);
		setAnexoData({ arquivo: null, descricao: '' });
	};

	const createDefaultValues = (initialData: Partial<CriarEtapaPayload>): FormValues => {
		const values: any = {
			id: initialData.id ?? null,
			nome: initialData.nome ?? '',
			aprovadorPrincipal: initialData.aprovadorPrincipal ?? 0,
			responsavelPrincipal: initialData.responsavelPrincipal ?? 0,
			aprovadoresSelecionados: initialData.aprovadoresSelecionados ?? [],
			responsaveisSelecionados: initialData.responsaveisSelecionados ?? [],
			acompanhamento: initialData.acompanhamento ?? '',
			fundamentacaoLegal: initialData.fundamentacaoLegal ?? '',
			datas: initialData.datas ?? '',
			prazoLegal: initialData.prazoLegal ?? '',
			temporalidade: initialData.temporalidade ?? '',
			ehLegal: initialData.ehLegal,
			formaCumprimento: initialData.formaCumprimento ?? '',
			listaEmailSelecionados: initialData.listaEmailSelecionados ?? [],
			listaEmailSomenteAtrasoSelecionados: initialData.listaEmailSomenteAtrasoSelecionados ?? [],
			tipoVencimento: initialData.tipoVencimento ?? null,
			parentId: obrigacao?.id,
			diaUtil: initialData.diaUtil,
			dataVencimento: initialData.dataVencimento ?? '',
			origemSelecionada: initialData.origemSelecionada,
			codigo: initialData.codigo,
			frequenciaSelecionada: initialData.frequenciaSelecionada ?? null,
			antecedenciaSelecionada: initialData.antecedenciaSelecionada ?? null,
			frequenciaVencidaSelecionada: initialData.frequenciaVencidaSelecionada ?? null,
			periodicidadeSelecionada: initialData.periodoSelecionado ?? null,
			// Campos adicionais
			justificativaAtraso: initialData.justificativaAtraso ?? '',
			justificativaCancelar: initialData.justificativaCancelar ?? '',
			justificativaImplementacao: initialData.justificativaImplementacao ?? '',
			justificativaNaoAprovacao: initialData.justificativaNaoAprovacao ?? '',
			justificativaNaoAprovacaoDataAlterada: initialData.justificativaNaoAprovacaoDataAlterada ?? '',
			justificativaNaoAprovarCancelamento: initialData.justificativaNaoAprovarCancelamento ?? '',
			pontoMelhoria: initialData.pontoMelhoria ?? '',
			reaprovada: initialData.reaprovada ?? false,
			obrigacaoConcluida: initialData.obrigacaoConcluida ?? false,
			emAtraso: initialData.emAtraso ?? false,
			emAtrasoDataFinalSolicitada: initialData.emAtrasoDataFinalSolicitada ?? false,
			podeConcluir: initialData.podeConcluir ?? false,
			dataConclusaoObrigacao: new Date(),
			dataHoje: new Date(),
			// Alteração data final
			observacao: initialData.observacao,
			dataFinalAnterior: initialData.dataVencimento,
			novaDataFinal: initialData.novaDataFinal,
			justificativaDataAlterada: initialData.justificativaDataAlterada || '',
			estadoStatusAprovada: initialData.estadoStatusAprovada,
			estadoStatusCancelamento: initialData.estadoStatusCancelamento || 0,
			estadoStatusAlterarData: initialData.estadoStatusAlterarData || 0,
			periodoSelecionado: initialData.periodoSelecionado,
			casoNaoUtilSelecionado: initialData.casoNaoUtilSelecionado || 2,
		};

		if (values.periodicidadeSelecionada === null && isEdit) {
			delete values.periodicidadeSelecionada;
		}

		return values;
	};

	const defaultValues = createDefaultValues(initialData);
	const ehAprovadorPrincipal = verificarAprovadorPrincipal(
		defaultValues.aprovadorPrincipal,
		defaultValues.aprovadoresSelecionados ?? [],
	);
	const ehResponsavelPrincipal = verificarResponsavelPrincipal(
		defaultValues.responsavelPrincipal,
		defaultValues.responsaveisSelecionados ?? [],
	);

	const {
		control,
		setValue,
		getValues,
		formState: { errors },
		handleSubmit,
		unregister,
	} = useForm<FormValues>({
		resolver: zodResolver(schema),
		defaultValues,
	});

	const handleAnexoSubmit = async () => {
		try {
			if (anexoData.arquivo && etapa?.id) {
				const res = await _obrigacoesService.criarAnexoObrigacao(
					empresaId,
					etapa.id,
					anexoData.arquivo,
					anexoData.descricao,
					EnumTipoAnexo.EtapaObrigacao,
					'usuarioAtivo',
				);

				if (res.isSuccess) {
					setAlert({
						type: 'success',
						content: 'Anexo criado com sucesso.',
						title: 'Sucesso!',
					});
					setAnexoData({ arquivo: null, descricao: '' });
					setPrecisaAtualizarListagem(true);
					onAlteracao?.(true);
				} else {
					setAlert({ type: 'error', content: 'Erro ao enviar o anexo.' });
				}
			} else {
				setAlert({ type: 'error', content: 'Nenhum arquivo foi selecionado.' });
			}
		} catch {
			setAlert({
				type: 'error',
				content: 'Ocorreu um erro ao criar o anexo. Tente novamente mais tarde.',
			});
		}
	};

	const onSubmit = async (data: FormValues) => {
		setLoading(true);
		setAlert(null); // Limpa alertas anteriores

		try {
			let response;
			if (!isEdit) {
				response = await _obrigacoesService.criarEtapa(empresaId, data);
			} else if (isEdit && etapa?.id) {
				response = await _obrigacoesService.atualizarEtapa(empresaId, etapa.id, data as CriarEtapaPayload);
			}

			if (response?.data) {
				onObrigacaoChange(response.data as unknown as TObrigacao);

				setAlert({
					type: 'success',
					content: 'Etapa salva com sucesso!',
					title: 'Sucesso!',
				});

				if (onAtualizar) {
					onAtualizar();
				}

				setTimeout(() => {
					onClose?.();
				}, 1000);
			}
		} catch (error: any) {
			const mensagemErro = error?.response?.data?.message || 'Erro ao salvar a obrigação. Tente novamente!';
			setAlert({
				type: 'error',
				content: mensagemErro,
				title: 'Erro',
			});
		} finally {
			setLoading(false);
		}
	};

	const handleChange = (field: string, value: unknown) => {
		setData((prevData) => ({
			...prevData,
			[field]: value,
		}));
	};

	return (
		<form
			onSubmit={(ev) => {
				ev.preventDefault();
			}}
		>
			<CustomHeader
				titulo='Etapa'
				isEdit={isEdit}
				empresaNome={empresaNome || ''}
				dataVencimento={data.dataVencimento?.toString() || ''}
				obrigacao={initialData}
				obrigacaoDefault={obrigacao}
				isModalLogs={isModalLogs}
				openAlterarVencimentoModal={handleOpenAlterarVencimentoModal}
				openConcluirObrigacaoModal={handleOpenConcluirObrigacaoModal}
				openModalLogs={setIsModalLogs}
				usuarioAprovador={ehAprovadorPrincipal}
				usuarioResponsavel={ehResponsavelPrincipal}
				onAttachClick={handleAttachClick}
			/>

			<Box sx={{ padding: 2, margin: '30px 0 0 0' }}>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={12} md={7} lg={6} xl={6}>
						<GerenciarObrigacao
							data={data}
							setValue={setValue}
							getValues={getValues}
							isEdit={isEdit}
							empresaId={empresaId}
							control={control}
							errors={errors}
							onChange={handleChange}
							usuarioAprovador={ehAprovadorPrincipal}
							usuarioResponsavel={ehResponsavelPrincipal}
						/>
					</Grid>
					<Grid item xs={12} sm={12} md={5} lg={6} xl={6}>
						<Grid container spacing={2}>
							{!isEdit && (
								<Grid item xs={12}>
									<CalculoPeriodicidade
										obrigacao={obrigacao}
										tipoDado={TipoDadoEnum.Etapa}
										control={control}
										errors={errors}
										setValue={setValue}
										getValues={getValues}
									/>
								</Grid>
							)}

							<Grid item xs={12}>
								<EnvioEmails
									control={control}
									errors={errors}
									empresaId={empresaId}
									setValue={setValue}
									getValues={getValues}
									usuarioAprovador={ehAprovadorPrincipal}
									usuarioResponsavel={ehResponsavelPrincipal}
									isEdit={isEdit}
								/>
								<LogsModal
									isModalLogs={isModalLogs}
									setIsModalLogs={setIsModalLogs}
									empresaId={empresaId}
									obrigacaoId={initialData.id}
								/>
							</Grid>

							{isEdit && (
								<Grid item xs={12}>
									<AcoesAnexo
										empresaId={empresaId}
										setValue={setValue}
										getValues={getValues}
										control={control}
										unregister={unregister}
										usuarioAprovador={ehAprovadorPrincipal}
										usuarioResponsavel={ehResponsavelPrincipal}
										aprovadoresSelecionados={data.aprovadoresSelecionados || []}
										responsaveisSelecionados={data.responsaveisSelecionados || []}
										openConcluirObrigacaoModal={handleOpenConcluirObrigacaoModal}
										openAlterarVencimentoModal={handleOpenAlterarVencimentoModal}
										openCancelarObrigacaoModal={handleOpenCancelarObrigacaoModal}
										data={data}
										onAttachClick={handleAttachClick}
										tipoDado={TipoDadoEnum.Etapa}
									/>
								</Grid>
							)}
						</Grid>
					</Grid>
				</Grid>

				<Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '1rem', gap: '20px' }}>
					<Button
						style={{ color: '#041F1F', backgroundColor: '#FFDAD6' }}
						type='filled-tonal'
						variant='error'
						onClick={(ev) => {
							ev.preventDefault();
							handleCloseFormulario();
						}}
						itemType='button'
						disabled={loading}
					>
						Cancelar
					</Button>
					<Button
						style={{
							backgroundColor: '#CCE8E7',
							color: '#041F1F',
						}}
						variant='save'
						loading={loading}
						disabled={
							obrigacaoEstaConcluida(data.estadoStatusAprovada ?? 0) ||
							(usuarioEhAdmin(usuario?.funcao, ehResponsavelPrincipal) && isEdit)
						}
						onClick={() => {
							setAlert(null);
							handleSubmit(onSubmit)();
						}}
					>
						Salvar
					</Button>
				</Box>
			</Box>

			<ModalConcluirObrigacao
				isVisible={isModalConluirObrigacao && dadosCarregados}
				onClose={() => setIsModalConluirObrigacao(false)}
				getValues={getValues}
				setValue={setValue}
				control={control}
				unregister={unregister}
				usuarioAprovador={ehAprovadorPrincipal}
				usuarioResponsavel={ehResponsavelPrincipal}
				handleSubmit={handleSubmit(onSubmit)}
			/>

			<ModalAlterarData
				isVisible={isModalAlterarVencimento && dadosCarregados}
				onClose={() => setIsModalAlterarVencimento(false)}
				getValues={getValues}
				setValue={setValue}
				control={control}
				unregister={unregister}
				usuarioAprovador={ehAprovadorPrincipal}
				usuarioResponsavel={ehResponsavelPrincipal}
				handleSubmit={handleSubmit(onSubmit)}
				obrigacao={obrigacao}
				tipoDado={TipoDadoEnum.Etapa}
			/>

			<ModalCancelarObrigacao
				isVisible={isModalCancelarObrigacao && dadosCarregados}
				onClose={() => setIsModalCancelarObrigacao(false)}
				getValues={getValues}
				setValue={setValue}
				control={control}
				unregister={unregister}
				usuarioAprovador={ehAprovadorPrincipal}
				usuarioResponsavel={ehResponsavelPrincipal}
				handleSubmit={handleSubmit(onSubmit)}
			/>

			<Anexos
				empresaId={Number(empresaId)}
				data={anexoData}
				etapa={etapa}
				obrigacao={obrigacao}
				onChange={handleAnexoChange}
				onSave={handleAnexoSubmit}
				isVisible={isModalAnexosVisible && dadosCarregados}
				onAtualizar={onAtualizar}
				onClose={handleCloseAnexosModal}
				origem='formulario'
				setPrecisaAtualizarListagem={setPrecisaAtualizarListagem}
				tipoDado={TipoDadoEnum.Etapa}
			/>

			{alert && <CustomAlert type={alert.type} content={alert.content} title={alert.title} />}
		</form>
	);
};

export default FormEtapas;
